import { render } from "./FormDefaultNewTwoConsent.vue?vue&type=template&id=cb2d1258"
import script from "./FormDefaultNewTwoConsent.vue?vue&type=script&lang=js"
export * from "./FormDefaultNewTwoConsent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QCheckbox,QSelect,QItem,QExpansionItem,QMenu,QForm,QCard,QCardSection,QInput,QItemSection,QItemLabel,QBtn});
